export default "__VITE_ASSET__Cbdxj25F__"